import { SubscriptionsRepository } from "../repositories/SubscriptionsRepository";

export class CreateSubscriptionWithPaypal {
	constructor(private repository: SubscriptionsRepository) {}

	execute(params: CreateSubscriptionWithPaypalParams): Promise<string> {
		return this.repository.createSubscriptionWithPaypal(params.subscription_id);
	}
}

export class CreateSubscriptionWithPaypalParams {
	constructor(public subscription_id: string) {}
}
